import * as React from 'react'

function SvgIconBrightnessMin(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g
        id="brightness-min"
        aria-labelledby="t-brightness-min d-brightness-min"
      >
        <title id="t-brightness-min">{'Brightness min'}</title>
        <desc id="d-brightness-min">{'A circle radiating no lines'}</desc>
        <path d="M16 12c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0 10c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6z" />
      </g>
    </svg>
  )
}

export default SvgIconBrightnessMin
